import Navbar from "../components/Navbar"
import Hero from "../components/Hero"
import FeaturedServices from "../components/FeaturedServices"
import FeaturedProjects from "../components/FeaturedProjects"
import AboutPreview from "../components/AboutPreview"
import ContactInfo from "../components/ContactInfo"
import Footer from "../components/Footer"
import SEOMetaTags from "../components/SEOMetaTags"

function Home() {
  return (
    <div className="min-h-screen bg-white">
      <SEOMetaTags 
        title="Buğra Teknik Servis - Karabük'te Profesyonel Teknik Servis"
        description="Karabük'te doğal gaz tesisatı, su tesisatı, kombi bakım onarım, klima servisi ve beyaz eşya servisi. 14+ yıl deneyim, 1000+ mutlu müşteri."
      />
      <Navbar />
      <Hero />
      <FeaturedServices />
      <FeaturedProjects />
      <AboutPreview />
      <ContactInfo />
      <Footer />
    </div>
  )
}

export default Home
